import { promptVars } from '../variables';
import { structureWithSchemaBasePrompt, } from './structureBasePrompt';
export const generateStructureDetailsPrompt = structureWithSchemaBasePrompt
    .temp(0.5)
    .human('Give me a structure of the application.')
    .ai(promptVars.structureDsl)
    .human('Create details with fields for all entities in the structure. Connect the details to detail scopes related to the entity.');
//# sourceMappingURL=generateStructureDetailsPrompt.js.map